const orderSettingsStored = JSON.parse(
  localStorage.getItem("orderSettingsStored") as string
);
const initialState = orderSettingsStored
  ? { orderSettings: orderSettingsStored }
  : { orderSettings: {} };

export const orderSettings = {
  namespaced: true,
  state: initialState,
  actions: {
    setOrderSettings({ commit }: any, current: { settings: any; index: any }) {
      commit("setOrderSettings", current);
      localStorage.setItem(
        "orderSettingsStored",
        JSON.stringify(this.state.orderSettings.orderSettings)
      );
    },
  },
  mutations: {
    setOrderSettings(state: any, current: any) {
      state.orderSettings[current.index] = current.settings;
    },
  },
};
